// A deleted project UUID is permanent queue audit history. It must never be
// treated like an ordinary Stop/Skip cancellation, rebound to a rescanned
// source folder, or accepted by a later enqueue call.
export function isProjectDeletionTombstone(job: any) {
    if (!job || typeof job !== 'object') return false;

    const reviewCode = String(job.reviewCode ?? job.review_code ?? '').trim().toUpperCase();
    const completionOutcome = String(
        job.completionOutcome ?? job.completion_outcome ?? '',
    ).trim().toLowerCase();
    const retiredReason = String(
        job.projectRetiredReason
        ?? job.project_retired_reason
        ?? job.reviewDetails?.reason
        ?? job.review_details?.reason
        ?? '',
    ).trim().toLowerCase();

    return reviewCode === 'PROJECT_DELETED'
        || completionOutcome === 'project-deleted'
        || retiredReason === 'project-deleted';
}
